/* ThermoAspen Stove Placeholder 1.0.0
 * The ONE place for the provisional stove footprint and clearances used before a manufacturer model has been resolved
 * (drag preview, initial position, room drawing). These are NOT clearance authority: manufacturer geometry and shielding
 * come from the Heater Catalogue through the Heater System Engine and are saved in project.heater.resolved.
 * Must load before the Bench Geometry Engine, Interior Workspace, Sauna Designer and Interior Layout scripts. */
(function (W) {
  'use strict';
  var P = {
    version: '1.0.0',
    provisional: true,
    widthMm: 450,
    depthMm: 450,
    heightMm: 750,
    rearGapMm: 100,
    sideClearanceMm: 150,
    frontClearanceMm: 600
  };
  Object.freeze(P);
  W.ThermoAspenStovePlaceholderV1 = P;
})(window);
